import React, { useState } from 'react';
import insurerPic from './Images/HDFC_Life_Logo.svg.png';
import { CountYear, convertIntoLakh, CommaSeprator, decimaNumberFormat } from './UtilityComponents/UtilityFunction';
import CircleLoader from './UtilityComponents/CircleLoader';
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";

const SMCInvestmentCompare = ({ Close, CompareItem, BuyNow, EnquiryNo }) => {
    const [IsLoader, setLoader] = useState(null);
    const [isDownloadPDF, setDownloadPDF] = useState(false);


    const generatePDF = async () => {
        setDownloadPDF(true);
        let element = document.getElementById('comparePopupBox');
        let clonnedElement = element.cloneNode(true);
        const backBtn = clonnedElement.querySelector('.backToQuotes');
        const pdfBtn = clonnedElement.querySelector('.CallRequest');
        if (backBtn) backBtn.remove();
        if (pdfBtn) pdfBtn.remove();
        let opt = {
            margin: 0.5,
            filename: (EnquiryNo || '').replace("/", "_") + "_CompareQuotaions" + '_Summary.pdf', //SMC/ENQ/23/1234_Quotation_Summary.pdf
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 8, letterRendering: true, useCORS: true, dpi: 192 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: clonnedElement.scrollHeight,
            // pagebreak: { mode: 'avoid-all', before: '.part2break' }
        };
        try {
            await html2pdf().set(opt).from(clonnedElement).save();
            setDownloadPDF(false);
        } catch (err) {
            // Handle error
            console.error(err);
        }
    }

    return (
        <>
            {isDownloadPDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
            < div id="mySidenav" className="CompareSideModel" >
                <div className="comparePage" id="comparePopupBox">

                    <div class="CallRequest">
                        <button onClick={generatePDF} class="showOpt" id="MoreOption">
                            <span><BsStars /></span>
                            <span><FaRegFilePdf /></span>
                            <span>Generate PDF</span>
                        </button>
                    </div>
                    <div className="CompRowFirst">
                                <div className="backToQuotes" onClick={() => Close(false) }>
                                    <a className="closebtns CompDetails"><i className="fas fa-long-arrow-alt-left"></i> Back to Quotation</a>
                                </div>
                        <div className="container">
                            <div className="CompRow">

                                {CompareItem.map((item)=><div className="CompCol">
                                    <div className="Qlogo">
                                        <img src={item.Image} />
                                    </div>
                                    <p className="">{item.PlanName}</p>
                                    <button className="CompareModelBtn" onClick={() => { setLoader(item.InsurerId); BuyNow(item) }}> {item.InsurerId === IsLoader ?  <CircleLoader /> : <>  Invest Now <strong className="CompareNetPremium"> &nbsp;₹{CommaSeprator(item.NetPremium)}</strong> /yr</>}</button>
                                </div>)}

                            </div>
                        </div>
                    </div>
                    <div className="CompColData">
                        <div className="container">
                            <div className="DividerRow text-center">
                                <span>You Pay</span>
                            </div>
                            <div className="CompRow">
                                {CompareItem.map((item)=> < div className="CompCol">
                                    <div>
                                        <p>₹{convertIntoLakh(parseInt(item?.ModelPremium) * parseInt(item?.PaymentTerm))}</p>
                                        <p>till {CountYear(item?.PaymentTerm)}</p>
                                    </div>
                                </div>)}
                            </div>

                            <div className="DividerRow text-center">
                                    <span>You Get</span>
                                </div>
                            <div className="CompRow">
                                {CompareItem.map((item)=><div className="CompCol">
                                    <div>
                                        <p>₹{convertIntoLakh(parseInt(item?.MaturityBenefit)?.toFixed(2))}</p>
                                        <p>in {CountYear(item?.PolicyTerm) }</p>
                                    </div>
                                </div>)}
                               
                            </div>
                            <div className="DividerRow text-center">
                                <span>Maturity Benefit</span>
                            </div>
                            <div className="CompRow">
                                {CompareItem.map((item) =><div className="CompCol">
                                    <div>
                                        <p>₹{CommaSeprator(decimaNumberFormat(item.MaturityBenefit))}</p>
                                    </div>
                                </div>)}
                            </div>
                            <div className="DividerRow text-center">
                                    <span>Tax Savings</span>
                                </div>
                            <div className="CompRow">
                                {CompareItem.map((item)=><div className="CompCol">
                                    <div>
                                        <p>₹{CommaSeprator(decimaNumberFormat(item.TotalTaxSaving))}</p>
                                    </div>
                                </div>)}
                               
                            </div>
                            <div className="DividerRow text-center">
                                    <span>Death Benefit</span>
                                </div>
                            <div className="CompRow">
                                {CompareItem.map((item)=><div className="CompCol">
                                    <div>
                                        <p>₹{CommaSeprator(decimaNumberFormat(item.DeathBenefit))} /1st Year</p>
                                    </div>
                                </div>)}
                                
                            </div>
                            <div className="DividerRow text-center">
                                    <span>Claim Settlement Ratio</span>
                                </div>
                            <div className="CompRow">
                                {CompareItem.map((item)=><div className="CompCol">
                                    <div>
                                        <p>{item.ClaimSettlementRatio}</p>
                                    </div>
                                </div>)}
                            </div>
                            <div className="DividerRow text-center">
                                    <span>{CompareItem[0]?.PlanFeatures[0]?.FeatureName}</span>
                                </div>
                            <div className="CompRow">
                                {CompareItem.map((item) => (
                                    <div className="CompCol">
                                    <div>
                                            {item.PlanFeatures.map((row) => (<p>{row.FeatureDescription === "" ? "NA" : (<ul>{row.FeatureDescription.split("|").map(f => <li>{f}</li>)}</ul>) }</p> ))}
                                    </div>
                                </div>))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default SMCInvestmentCompare;